var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 262 30",
    style: {
      enableBackground: "new 0 0 262 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.2,5.3 9.4,5.3 23.8,18.4 23.8,5.3 28.7,5.3 28.7,25.5 23.8,25.5 9.1,12.1 9.3,25.5 4.2,25.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4,
    y: 5.3,
    className: "st0",
    width: 4.8,
    height: 20.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "48.9,5.3 53.8,5.3 53.8,21.1 65.5,21.1 65.5,25.5 49.1,25.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.1,5.3 91.1,5.3 91.1,9.3 77,9.3 77,13.2 88,13.2 88,17.3 77,17.3 77,25.2 72.1,25.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.6,
    y: 5.3,
    className: "st0",
    width: 4.9,
    height: 20.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.1,5.3l-16.4,0c0,0-5,0.2-5,6c0,5.3,4.8,5.8,4.8,5.8s11.2,0,11.9,0c1,0,2.3,3.5-0.2,4.2 c-1.1,0-15.5,0-15.5,0v4.2l16.8,0c0,0,4.6-1.3,4.6-5.9c0.7-6-5-6.5-5-6.5s-9.3,0.2-11.5,0c-2-0.8-1.4-2.6-0.8-3.4 c0.2-0.2,0.9-0.3,1.2-0.3l15.2,0.1V5.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "137,5.3 142.1,5.3 142.1,13.8 151.9,5.3 158.3,5.3 147.1,15.1 158.3,25.2 152,25.2 142,16.4  142.1,25.5 137,25.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.4,18.9c-0.1,1-0.4,2-0.7,2.8c-0.4,0.8-0.9,1.5-1.5,2.1c-0.6,0.6-1.4,1-2.3,1.3c-0.9,0.3-1.9,0.5-3,0.5 c-1.2,0-2.2-0.2-3.2-0.7c-0.9-0.4-1.8-1.1-2.4-1.9s-1.2-1.8-1.6-2.9c-0.4-1.1-0.5-2.4-0.5-3.8v-2.6c0-1.4,0.2-2.6,0.5-3.8 s0.9-2.1,1.6-2.9c0.7-0.8,1.5-1.4,2.5-1.9c1-0.4,2.1-0.7,3.3-0.7c1.1,0,2.1,0.2,2.9,0.5c0.9,0.3,1.6,0.7,2.2,1.3 c0.6,0.6,1.1,1.3,1.5,2.1c0.4,0.8,0.6,1.8,0.7,2.8h-1.7c-0.1-0.8-0.3-1.6-0.6-2.2c-0.3-0.7-0.6-1.2-1.1-1.6c-0.5-0.4-1-0.8-1.7-1 C185.6,6.1,184.8,6,184,6c-1,0-1.8,0.2-2.6,0.6c-0.8,0.4-1.4,0.9-1.9,1.6c-0.5,0.7-0.9,1.5-1.2,2.4c-0.3,1-0.4,2-0.4,3.2v2.6 c0,1.1,0.1,2.2,0.4,3.1c0.3,1,0.6,1.8,1.2,2.5c0.5,0.7,1.1,1.2,1.9,1.6c0.7,0.4,1.6,0.6,2.5,0.6c1.8,0,3.2-0.4,4.1-1.3 c0.9-0.9,1.5-2.2,1.7-3.9H191.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.3,25.3h-1.7v-9.8h-11.7v9.8h-1.7V4.8h1.7V14h11.7V4.8h1.7V25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.2,25.3h-1.7V4.8h1.7V25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230,23.8h10.1v1.5h-11.9V4.8h1.7V23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.3,15.5h-9.6v8.4h11v1.5H245V4.8h12.7v1.5h-11V14h9.6V15.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.d92eba95737c922b2ad4a9cb1dd76200.svg";
export { ForwardRef as ReactComponent };